<div class="anchor-tabs-buttons-container">
  <div
    class="section-button-container section-button-container-left-content"
    [ngClass]="{ 'back-left-selected': selectedTab() === 'left' }">
    <div
      class="section-inner-content"
      [ngClass]="{ 'content-unselected': selectedTab() === 'right' }">
      <div class="section-inner-content-icon section-inner-content-icon-coin"></div>
      <div class="section-inner-content-text">
        {{ 'home.shop.coins' | translate }}
      </div>
    </div>
  </div>
  <div
    class="section-button-container section-button-container-left"
    (click)="onTabClicked(0)"></div>
  <div
    class="section-button-container section-button-container-right"
    (click)="onTabClicked(1)"></div>
  <div
    class="section-button-container section-button-container-right-content"
    [ngClass]="{ 'back-right-selected': selectedTab() === 'right' }">
    <div
      class="section-inner-content"
      [ngClass]="{ 'content-unselected': selectedTab() === 'left' }">
      <div class="section-inner-content-icon section-inner-content-icon-gem"></div>
      <div class="section-inner-content-text">
        {{ 'home.shop.gems' | translate }}
      </div>
    </div>
  </div>
</div>

<div class="anchor-tabs-buttons-container-glass"></div>

<div
  id="anchor-tab-container"
  class="anchor-tabs-container">
  <!-- <div class="bounce-section"></div> -->
  <div
    id="credits-section"
    class="tab-section tab-section-{{ selectedTab() }}">
    @for (item of inventory.Coins; track item; let i = $index) {
      <slotcom-shop-item
        attr.data-testid="slotcom-shop-tariffCoins-{{ i }}"
        id="{{ item.id }}"
        [type]="'coin'"
        [user]="user"
        [item]="item"
        [index]="i + 1"
        [active]="active"
        [ngClass]="{ 'shop-item-disabled': !active }">
      </slotcom-shop-item>
    }
  </div>
  <div
    id="gems-section"
    class="tab-section tab-section-{{ selectedTab() }}">
    @for (item of inventory.Gems; track item; let i = $index) {
      <slotcom-shop-item
        attr.data-testid="slotcom-shop-tariffGems-{{ i }}"
        id="{{ item.id }}"
        [type]="'gem'"
        [user]="user"
        [item]="item"
        [index]="i + 1"
        [active]="active"
        [ngClass]="{ 'shop-item-disabled': !active }">
      </slotcom-shop-item>
    }
  </div>
  <!-- <div class="bounce-section"></div> -->
</div>
